module.exports = __webpack_public_path__ + "img/point.da9d8cdc.png";